<template>
  <div class="container">
    <!-- <div class="loadingsec" v-if="loading = true">
        <div class="loader"></div>
        <h2 class="loading">Loading..</h2>
    </div> -->
    <b-row>
      <b-col lg="6" sm="12">
        <h2 class="giftVoucher">Gift Vouchers</h2>
      </b-col>
      <b-col lg="6" sm="12">
        <b-link @click="scrollBalance()"> 
          <button data-v-1c8f3b1f="" class="buttonSelectCheck">Check my Balance</button>
        </b-link>
      </b-col>
    </b-row>
    <b-row class="giftVOUCHER">
      <b-col lg="6" sm="12" class="mobStyle">
        <img src="https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Voucher_Sim_Park-scaled.png" class="simparkImage">
      </b-col>
      <b-col>
        <h2 class="giftCard">Custom Amount Gift Voucher Redeemable on Any Simulator Experience – Race, Golf, or Flight
        </h2>
        <p class="giftAmount"></p>
          <!-- money sldier -->
          <!-- <div class="moneyValue">
            <span class="slidervalue">
              £ <span v-if="sliderValue == 0">{{ value }}</span> {{ sliderValue }}
              
            </span>
              <range-slider
                class="slider"
                min="20"
                max="2000"
                step="5"
                :value="sliderValue"
                v-model="sliderValue">
              </range-slider>
          </div> -->
          <div class="buttonArea" style="    margin-bottom: 22px;">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: '13',
                      price: sliderValue
                    },
                  }"
            >
              <button class="buttonSelect">Buy Gift Voucher</button>
            </b-link>
          </div>
      </b-col>
    </b-row>

    <h2 class="giftVoucher">Gift Vouchers Ideas</h2>
    <!-- Golf Section -->
    <b-row class="padExtra">
      <b-col lg="3" class="backgroundImage golf" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Golf.jpg' + ')' }">
      </b-col>
      <b-col lg="3" v-for="(gift, index) in acf.acf.vouchers_golf.slice(0,3)" :key="index">
        <div class="imageSection" v-bind:style="{ 'background-image': 'url(' + gift.image + ')' }">
        </div>
        <div class="textArea">
          <h2 class="giftTitle" v-html="gift.title"></h2>
          <!-- <p class="giftMoney">£{{gift.money_value}}</p> -->
          <div class="buttonArea">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: gift.num,
                    },
                  }"
            >
              <button class="buttonSelect">More Information</button>
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Flight Section -->
    <b-row class="padExtra">
      <b-col lg="3" class="backgroundImage flight" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Flight.jpg' + ')' }">
      </b-col>
      <b-col lg="3" v-for="(gift, index) in acf.acf.vouchers_flight" :key="index">
        <div class="imageSection" v-bind:style="{ 'background-image': 'url(' + gift.image + ')' }">
        </div>
        <div class="textArea">
          <h2 class="giftTitle" v-html="gift.title"></h2>
          <!-- <p class="giftMoney">£{{gift.money_value}}</p> -->
          <div class="buttonArea">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: gift.num,
                    },
                  }"
            >
              <button class="buttonSelect">More Information</button>
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Race Section -->
    <b-row class="padExtra">
      <b-col lg="3" class="backgroundImage race" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Race.jpg' + ')' }">
      </b-col>
      <b-col lg="3" v-for="(gift, index) in acf.acf.vouchers_race" :key="index" class="racePad">
        <div class="imageSection" v-bind:style="{ 'background-image': 'url(' + gift.image + ')' }">
        </div>
        <div class="textArea">
          <h2 class="giftTitle" v-html="gift.title"></h2>
          <!-- <p class="giftMoney">£{{gift.money_value}}</p> -->
          <div class="buttonArea">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: gift.num,
                    },
                  }"
            >
              <button class="buttonSelect">More Information</button>
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Race Extra Section -->
    <b-row class="padExtra" style="display:none">
      <b-col lg="3" class="backgroundImage race" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Race.jpg' + ')' }">
      </b-col>
      <b-col lg="3" v-for="(gift, index) in acf.acf.vouchers_raceextra" :key="index" class="racePad">
        <div class="imageSection" v-bind:style="{ 'background-image': 'url(' + gift.image + ')' }">
        </div>
        <div class="textArea">
          <h2 class="giftTitle" v-html="gift.title"></h2>
          <p class="giftMoney">£{{gift.money_value}}</p>
          <div class="buttonArea">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: gift.num,
                    },
                  }"
            >
              <button class="buttonSelect">More Information</button>
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Sim Section -->
    <b-row class="padExtra" style="display:none">
      <b-col lg="3" class="backgroundImage sim" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Sim.jpg' + ')' }">
      </b-col>
      <b-col lg="3" v-for="(gift, index) in acf.acf.vouchers_simpark" :key="index">
        <div class="imageSection" v-bind:style="{ 'background-image': 'url(' + gift.image + ')' }">
        </div>
        <div class="textArea">
          <h2 class="giftTitle" v-html="gift.title"></h2>
          <p class="giftMoney">£{{gift.money_value}}</p>
          <div class="buttonArea">
            <b-link
                  :to="{
                    name: 'vouchers',
                    query: {
                      code: gift.num,
                    },
                  }"
            >
              <button class="buttonSelect">More Information</button>
            </b-link>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Check Gift Voucher Balance -->
    <b-row class="balanceSection" id="check_balance">
      <b-col lg="6" sm="12">
        <h2 class="balanceTitle">Check your Gift Voucher Balance</h2>
        <b-form-group
          label-for="input-lazy"
          class="mb-0 buyersName"
        >
          <b-form-input
            id="input-lazy"
            v-model="voucherNum"
            lazy-formatter
            :formatter="formatter"
            placeholder="Enter Gift Voucher Code"
          ></b-form-input>
        </b-form-group>
        <br>
        <b-form-datepicker id="datepicker-placeholder" placeholder="Purchase Date"  v-model="purchaseDate" class="mb-2"></b-form-datepicker>
        <!-- <p>Value: '{{ purchaseDate }}'</p> -->
        <template v-if="voucherNum.includes('GPK') || voucherNum.includes('RPK') || voucherNum.includes('FPK') || voucherNum.includes('ALL')" >
          <button class="checkBalance" @click="getBalance">Check Balance</button>
        </template>
        <template v-else>
          <button class="checkBalance dis">Check Balance</button>
          <!-- <b-button disabled class="checkBalance dis">Check Balance</b-button> -->
        </template>
      </b-col>
      <b-col class="reverse" lg="6" sm="12">
        <transition name="flip" mode="out-in">
            <div key="login" class="login-boxset" v-if="isShowing" @click="getBalance" >
                <img src="https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Voucher_Sim_Park-scaled.png" class="giftBox">
            </div>
            <div key="register" class="login-box" v-else>
              <h2 class="availableBalance">Available Balance</h2>
              <h2 class="availableMoney">
                <span v-if="vcData.gift == 'N'">
                  Sessions: {{vcData.balance_slots}}
                </span>
                <span v-else>
                  £{{vcData.gift_balance}}
                </span>
              </h2>
              <p class="voucherExpires">Voucher Expires : {{vcData.expiry_date}}</p>
            </div>
          </transition>
          <div style="display:none;">
            <div id="front">
            </div>
            <div id="back" >
                <h2 class="availableBalance">Available Balance</h2>
                <h2 class="availableMoney">
                  <span v-if="vcData.gift == 'N'">
                    Sessions: {{vcData.balance_slots}}
                  </span>
                  <span v-else>
                    £{{vcData.gift_balance}}
                  </span>
                </h2>
                <p class="voucherExpires">Voucher Expires : {{vcData.expiry_date}}</p>
            </div>
          </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
// import RangeSlider from 'vue-range-slider'
// you probably need to import built-in style
// import 'vue-range-slider/dist/vue-range-slider.css'
export default {
  name: 'Vouchers',
  components: {
    // RangeSlider
  },
  data: function() {
    return {
      acf: [],
      voucherNum: '',
      purchaseDate: '',
      data: [],
      vcData:[],
      sliderValue: '',
      value: '20',
      loading: true,
      isShowing: true,
    };
  },
  methods: {
    scrollBalance() {
      var score = document.getElementById("check_balance");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    checkVC() {
      console.log('IN checlVC')
      const dateString = this.purchaseDate;
      const [day, month, year] = dateString.split("-"); 
      // Only way to get the below to work was to reverse the login in american format
      let vcode = '2000029000 ' + "'" + this.voucherNum + '&'  + year + month + day + '&' + "'"; 
      // console.log("vcode")
      // console.log(vcode)
      return vcode
		}, 
    getBalance() {
      console.log('Get Balance');
      let sktMsg = this.checkVC();
      this.$socket.emit('checkvc', sktMsg);
      this.checkBalance();
    },
    checkBalance : function() {
      this.sockets.subscribe('respcheckvc', (data) => {
        const a = JSON.parse(data)
        console.log(a)
        this.vcData = a;
      })
      var x = document.getElementById("front");
      var y = document.getElementById("back");
      if (x.style.display === "none") {
        x.style.display = "block";
        y.style.display = "none";
      } else {
        x.style.display = "none";
        y.style.display = "block";
      }
      this.isShowing = false
    },
    getDataFull : function() {
      axios //add API Call
        .get(
            'https://wp-ocssport.ocs-sport.com/simpark' + "/wp-json/wp/v2/pages/169"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
          this.loading = true,
          this.acf = response.data,
          this.loading = false
        )); //API data wanted pulled out
    }
  },
  mounted() {
    this.loading = true,
    this.getDataFull(),
    this.loading = false
  }
}
</script>

<style scoped>
  .login-box {
    padding: 40px;
    /* transform: translate(-50%, -50%); */
    background: #000000;
    box-sizing: border-box;
    height: 306px;
    width: 94%;
    border-radius: 27px;
    margin-top: 25px;
  }

  .flip-enter-active, .flip-leave-active {
    transition: all .5s;
  }
  .flip-enter, .flip-leave-to {
    transform: rotateY(-90deg);
  }
button.checkBalance.dis {
  background-color: #888888;
  cursor: not-allowed;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.slider {
  /* overwrite slider styles */
  width: 100%;
}
::v-deep .range-slider-fill {
  background-color: #D80E1F!important;
}
::v-deep .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border: 1px solid #000000;
  border-radius: 50%;
  background-color: #000000;
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.giftVOUCHER {
  margin-bottom: 50px;
}
.moneyValue {
  /* padding-left: 18px; */
  margin-top: 40px;
}
span.slidervalue {
  color: #242533;
  font-size: 15px;
  font-style: italic;
  text-align: left;
  font-family: "korolev", sans-serif;
}
::v-deep .noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #000000;
  cursor: default;
  box-shadow: none;
}
span.slidervalue {
  color: black;
  font-size: 18px;
  text-align: left;
  width: 100%;
  display: block;
  padding-bottom: 20px;
  /* margin-left: -15px; */
}
h2.giftCard {
  color: #242533;
  font-size: 32px;
  font-style: italic;
  text-align: left;
  padding-top: 15px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
p.giftAmount{
  color: #242533;
  font-size: 20px;
  font-style: italic;
  text-align: left;
  padding-top: 15px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
img.simparkImage {
  width: 100%;
  margin-left: -70px;
}
.loadingsec {
  padding-top: 50px;
}
button.btn.checkBalance.dis.btn-secondary.disabled {
  cursor: not-allowed;
}
::v-deep span.btn.border-0.rounded-circle.text-nowrap.btn-outline-light.text-muted {
  width: 32px;
  height: 32px;
  font-size: 14px !important;
  line-height: 1;
  margin: 3px auto;
  padding: 9px 0;
}
h2.availableBalance {
  color: #fff;
  font-size: 24px;
  font-style: italic;
  text-align: left;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  padding-top: 24px;
}
h2.availableMoney {
  color: #fff;
  font-size: 75px;
  font-style: italic;
  text-align: left;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
p.voucherExpires {
  color: #fff;
  font-size: 24px;
  font-style: italic;
  text-align: left;
  font-family: "korolev", sans-serif;
  font-weight: 100;
}
#back {
  background: #000;
  color: #fff;
  height: 306px;
  width: 94%;
  border-radius: 27px;
  margin-left: 18px;
  padding: 41px;
  margin-top: 28px;
  display: none;
}
.flip-card {
  background-color: transparent;
  width: 300px;
  height: 300px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background-color: #bbb;
  color: black;
}
.flip-cardHover {
  background-color: #ff0000;
  color: black;
}

.flip-card-back {
  background-color: #2980b9;
  color: white;
  transform: rotateY(180deg);
}
img.giftBox {
  width: 100%;
  margin-top: 10px;
}
.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-back {
  background-color: #000;
  color: white;
  /* transform: rotateY(180deg); */
}
.reverse {
  /* transform: rotateY(180deg); */
}
.form-control {
  /* display: block; */
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  color: #242533;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  height: 60px;
  display: inline-flex
}
::v-deep label#datepicker-placeholder__value_ {
  padding-top: 10px;
  text-align: left;
}
::v-deep .text-muted {
  color: #6c757d !important;
  font-family: "korolev", sans-serif;
  font-style: italic;
  color: #C6C6C6;
  opacity: 0.4;
  font-size: 24px !important;
  padding-top: 5px!important;
}
::v-deep svg.bi-calendar.b-icon.bi {
  color: #c6c6c6;
}
::v-deep svg.bi-calendar.b-icon.bi:hover {
  color: #c6c6c6!important;
}
.balanceSection {
  background-color: #D80E1F;
  border-radius: 27px;
  height: 450px;
  padding: 80px;
  margin-bottom: 100px;
  padding-top: 40px;
}
.checkBalance {
  width: 398px;
  height: 54px;
  background-color: #000000;
  border-radius: 27px;
  color: #fff;
  border: none;
  font-weight: bold;
  /* font-style: italic; */
  margin-top: 22px;
  float: left;
  font-size: 20px;
}
.checkBalance:hover {
  width: 398px;
  height: 54px;
  background-color: #6f6f6f;
  border-radius: 27px;
  color: #fff;
  border: none;
  font-weight: bold;
  /* font-style: italic; */
  margin-top: 22px;
  float: left;
  font-size: 20px;
}
.loading {
  color: #242533;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 100px;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #000000;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  margin-bottom: 20px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.imageSection {
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
}
h2.balanceTitle {
  color: #fff;
  font-size: 40px;
  font-style: italic;
  text-align: left;
  padding-top: 15px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  padding-bottom: 20px;
}
h2.giftTitle {
  color: #242533;
  font-size: 25px;
  font-style: italic;
  text-align: left;
  padding-top: 15px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
p.giftMoney {
  color: #242533;
  text-align: left;
  font-style: italic;
  font-size: 20px;
  font-weight: bold;
  padding-top: 10px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
.form-control::placeholder {
  color: #C6C6C6;
  opacity: 1;
  font-size: 24px;
  position: relative;
  top: 5px;
  font-family: "korolev", sans-serif;
  font-style: italic;
  padding-left: 8px;
}
button.buttonSelect {
    background: #D80E1F;
    width: 95%;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: left;
}
button.buttonSelect:hover {
    background: #000;
    width: 95%;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: left;
}
button.buttonSelectCheck {
    background: #D80E1F;
    width: 300px;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: right;
    margin-top: 20px;
}
button.buttonSelectCheck:hover {
    background: #000;
    width: 300px;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: right;
}
.buttonArea {
    position: absolute;
    bottom: 0;
    width: 100%;
}
.padExtra {
  /* padding-bottom: 100px; */
  padding-bottom: 65px;
}
.backgroundImage.col-lg-3 {
  /* height: 50em; */
  background-repeat: no-repeat;
  background-size: contain;
  /* height: 462px; */
  height: 390px;
  background-position: center;
}
.golf {
  background-color: #ff8c15;
} 
.flight {
  background-color: #5d8ef0;
} 
.race {
  background-color: #d80e1f;
} 
.sim {
  background-color: #1a1a1a;
} 
h2.giftVoucher {
  color: #11182F;
  font-weight: bold;
  font-style: italic;
  font-size: 40px;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: left;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
.title {
  color: black;
}
.ContactSection {
  /* background-color: #1A1A1A; */
}
.ContactTitle {
  color: #fff;
  font-size: 65px;
  padding-top: 80px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
}
.WhiteStandard-text {
  font-size: 24px;
  color: #fff;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
}
.contact-width {
  width: 100%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 70px;
}
@media only screen and (max-width: 768px) {
  button.buttonSelectCheck {
    background: #D80E1F;
    width: 300px;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: none;
    margin-top: 00px;
    margin-bottom: 20px;
  }
  button.buttonSelectCheck:hover {
    background: #000000;
    width: 300px;
    height: 54px;
    border-radius: 27px;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    float: none;
    margin-top: 00px;
    margin-bottom: 20px;
  }
  #back {
    background: #000;
    color: #fff;
    height: 306px;
    width: 94%;
    border-radius: 27px;
    margin-left: 10px;
    padding: 41px;
    margin-top: 28px;
    /* padding-left: 0; */
    display: none;
  }
  .checkBalance {
    width: 100%!important;
    height: 54px;
    background-color: #000000;
    border-radius: 27px;
    color: #fff;
    border: none;
    font-weight: bold;
    /* font-style: italic; */
    margin-top: 22px;
    float: left;
    font-size: 20px;
  }
  .balanceSection{
    background-color: #D80E1F;
    border-radius: 27px;
    height: auto;
    padding: 0;
    margin-bottom: 100px;
    padding-top: 40px;
    padding-bottom: 40px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .backgroundImage.col-lg-3{
    /* height: 50em; */
    background-repeat: no-repeat;
    background-size: contain;
    /* height: 462px; */
    height: 390px;
    background-position: center;
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
  img.simparkImage {
    width: 100%;
    margin-left: 0px;
  }
  .simparkImage {
    padding-left: 0px;
    padding-right: 0px;
  }
  .imageSection {
    height: 200px;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: 30px;
  }
  .buttonArea{
    margin-top: 30px;
    position: inherit;
    bottom: 0;
    width: 100%;
  }
  .ContactTitle {
    color: #fff;
    font-size: 40px;
  }
  .WhiteStandard-text {
    font-size: 20px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .imagesInsert {
    width: 100%;
  }
::v-deep label#datepicker-placeholder__value_ {
    padding-top: 10px;
    text-align: left;
    font-size: 17px!important;
  }
  h2.availableMoney {
    font-size: 50px;
  }
}
</style>
